import axios from "axios";
// const URL = "http://localhost:8080/Api";

// pre-prod
// const URL =
//   "https://kris-bang.alwaysdata.net/api-inscription-online-tkd-cergy-elite/Api";

//prod-new
const URL =
  "https://inscription-online.alwaysdata.net/api-inscription-online-tkd-elite-cergy/Api";

const instance = axios.create({
  baseURL: URL,
});

if (sessionStorage.getItem("token") && sessionStorage.getItem("token") != "") {
  // console.log("sessionStorage.getItem(token)", sessionStorage.getItem("token"));
  instance.defaults.headers.common["Authorization"] = `${sessionStorage.getItem(
    "token",
  )}`;
}

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    // console.log("error", error);
    if (
      error.config.url != "/user/membre/checkToken" &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      if (
        sessionStorage.getItem("refreshToken") &&
        sessionStorage.getItem("refreshToken") != ""
      ) {
        instance.defaults.headers.common[
          "Authorization"
        ] = `${sessionStorage.getItem("refreshToken")}`;
        // console.log("refreshToken");
        instance
          .get("/user/membre/checkToken")
          .then((response) => {
            // console.log("response", response);
            // TODO: mettre à jour l'accessToken dans le sessionStorage
            sessionStorage.setItem("token", response.data.accessToken);
            sessionStorage.setItem(
              "refreshToken",
              response.data.accessTokenRefresh,
            );
            originalRequest.headers[
              "Authorization"
            ] = `${response.data.accessTokenRefresh}`;
            instance.defaults.headers.common[
              "Authorization"
            ] = `${response.data.accessTokenRefresh}`;
          })
          .catch((err) => {
            sessionStorage.setItem("refreshToken", null);
            console.log(err);
          });
        return instance(originalRequest);
      }
    }
    return Promise.reject(error);
  },
);

export default {
  instance: instance,
  api_url: URL,
};
